import React, {useEffect} from 'react';
import { useNavigate } from "react-router"

// Material UI
import { Grid, IconButton, Paper, Tooltip, Typography } from "@mui/material"
import { Receipt } from "@mui/icons-material"

//Components
import { DataGrid, ViewButton } from '@arredo/reactjs-ui';
import InvoiceFilters from "../../components/invoice/filters"

//Hooks
import useQueryString from "../../hooks/queryString/useQueryString"
import useVouchers from '../../hooks/vouchers/useVouchers';
import useStyles from './styles'
import useUser from '../../hooks/user/useUser';

import { channels } from '../../models/Channels'
import { GetVoucherTypeByCountry } from '../../models/EnumEntity';
import { title, columns } from "../../models/VoucherEntity"

const getDefaultFilters = (isFranchise) => ({
    pageSize: 10,
    pageNumber: 1,
    channel: isFranchise ? channels.values.Franchises : channels.values.Tienda
})

const Vouchers = () => {
    const { branch, business } = useUser();
    const { classes } = useStyles();
    const { setParameterSearch, filters, clearFilters } = useQueryString();
    const { vouchers, totalPage, loading } = useVouchers(filters);
    const push = useNavigate();

    useEffect(() => {
            if (business) {
                setParameterSearch({...getDefaultFilters(business.isFranchise)});
            }
        }, [business]);
    
    const handleChangePage = (e, page) =>
        setParameterSearch({
            ...filters,
            pageNumber: Number(page)
        });

    return (
        <Grid container spacing={1}>
            <Grid size={12}>
                <Paper className={classes.paper}>
                    <Typography align="center" variant="h4">
                        {title}
                    </Typography>
                </Paper>
            </Grid>
            <Grid size={12}>
                <InvoiceFilters
                    filters={filters}
                    clearFilters={clearFilters}
                    setFilters={setParameterSearch}
                    valuesTypeSelect={GetVoucherTypeByCountry(branch.country)}
                />
            </Grid>
            <Grid size={12}>
                <DataGrid
                    columns={columns}
                    loading={loading}
                    rows={vouchers}
                    actions={
                        ({ row }) => (
                            <>

                                <ViewButton
                                    to={`/cashRegisters/vouchers/${row.id}`}
                                />

                                <Tooltip title='Ver Factura'>
                                    <IconButton
                                        color='primary'
                                        onClick={() => push(`/cashRegisters/invoices/${row.voucherReference}`)}
                                        size="large"
                                    >
                                        <Receipt />
                                    </IconButton>
                                </Tooltip>
                            </>
                        )
                    }
                    paginationProps={{
                        count: totalPage,
                        page: Number(filters?.pageNumber || 1),
                        onChange: handleChangePage
                    }}
                />
            </Grid>
        </Grid>
    );
}
export default Vouchers;